export default function translate(i18n, propriete) {
  if (propriete === 'annee') {
    return i18n.t('indexation.popUpAddIndexation.year');
  }
  if (propriete === 'dateDebut') {
    return i18n.t('indexation.popUpAddIndexation.dateDebut');
  }
  if (propriete === 'dateFin') {
    return i18n.t('indexation.popUpAddIndexation.dateFin');
  }
  if (propriete === 'pourcentageIndexationParDefaut') {
    return i18n.t('indexation.taux');
  }
  return propriete;
}
